import './BookRide.css';
import React, { Fragment } from 'react';
import DepartureLocationForm from '../../components/departure_location/DepartureLocationForm';
import TripList from '../../components/trip_list/TripList';

function BookRide() {
  return (
    <section className='section-container'>
        <Fragment>
          <DepartureLocationForm/>
          <TripList/>
        </Fragment>
    </section>
  )
}

export default BookRide
